import React from "react";
import { Container } from "reactstrap";
import Typesix from "./Typesix";
export default function Swipetype() {
  return (
    <div>
      <Container fluid>
        <Typesix />
      </Container>
    </div>
  );
}
